<ng-container *ngrxLet="otp$; let otp">
  @if (identifier && otp) {
    @if (hasSignUpSuccess && hasSignInError) {
      <p class="login-confirmation-error">{{ 'errors.login.email_otp' | translate }}</p>
      <a class="registration-success"
         (click)="redirectToLogin()">
        {{ 'login.v2.login_redirect' | translate }}
      </a>
    } @else {
      <form class="registration-confirmation-form label-static is-empty"
            [ngClass]="{'input--filled': !!form.valid, submitted: !!submitted }"
            appJumptoError
            #appJumptoError="appJumptoError"
            [formGroup]="form"
            (ngSubmit)="onSubmit()">
        @if (formErrors) {
          <app-input-errors
              [errorsForField]="formErrors"
              [translationKey]="'errors.register'"/>
        }
        @if (consentsData.isConsentAvailable) {
          <app-signup-consents [formGroup]="form"
                               [formErrors]="formErrors"
                               [identifierType]="identifier.identifier_type"
                               [consentsTranslations]="consentsData.consentsTranslations"/>
          <app-privacy-policy
              formControlName="tos"
              [formErrors]="formErrors['tos'] ?? null"
              [customPrivacyPolicy]="consentsData.consentsTranslations | getConsentsTranslation:'general_privacy_policy'"/>
        }
        @if ((minimumMemberAge$ | async); as minimumMemberAge) {
          <div
              class="registration-confirmation-control d-flex">
            <label [for]="input" class="control-label">
              {{ 'login.v2.confirm_age' | translate:{ minimumMemberAge: minimumMemberAge } }}
              <span class="required">*</span>
            </label>
            <input formControlName="confirmAge"
                   class="form-control"
                   type="checkbox"
                   name="input"
                   #input
                   appFocusable
                   (onFocusChange)="$any(input).isFocused = $event"/>
          </div>
        }
        <button [disabled]="!form.valid" type="submit"
                class="registration-confirmation-submit btn btn-raised btn-block btn-primary login-page-submit">
          <span>{{ 'profiles.new.title' | translate }}</span>
        </button>
      </form>
    }
  } @else {
    @if (otp) {
      <missing-identifier-info
          [otp]="otp"
          infoTranslationKey="errors.register.missing_identifier"/>
    } @else {
      <p>{{ 'errors.register.email_otp' | translate }}</p>
    }
  }
</ng-container>
